module.exports = __webpack_public_path__ + "img/1.a7a74ab9.jpg";